.wrapper {
    position: relative;
    display: block;
    width: 100%;
    aspect-ratio: 24/10;
    max-height: 600px;
}

.media {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    object-fit: cover;
}
